export default function($form) {
  var $params=$form.getExtForm();
  /*作废不用验证表单 yhq 20191031
  if (!$form.isValid(true)) {
    return;
  }*/
  var p ={
    taskId:$params.taskId,
    appId:$params.appId,
    formId:$params.formId
  }
  $params.btnDebounce(function(){
    var btnName = $params.action;
    $params.setBtnLoading(true,btnName);
    PF.confirm($lang('您确定将此文件作废？请谨慎操作！'), $lang('提示'), {type:'info'}).then(()=>{
      let params = [];
      var param = {
         moduleId:$params.moduleId,
         businessId:$params.businessId,
         taskId:$params.taskId
      }
      if($params.extParams && $params.extParams.fullAuthType){
        param.fullAuthType = $params.extParams.fullAuthType;
      }
      params.push(param)
      PF.api.process.batchSuspendReleaseWH(params).then(res=>{
        $form.fireEvent("aftertovoid", $params, res.success);
        if(res.success){
          $params.formActionComplete(); //关闭窗口
        }
        $params.setBtnLoading(false,btnName);
      }).catch(()=>{
        $params.setBtnLoading(false,btnName);
      });
    }).catch(()=>{
      $params.setBtnLoading(false,btnName);
    });
  });
}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-tovoid.js